import React, { useEffect } from "react";
import RrbDropdownUi from "./RrbDropdownUi";
import $ from "jquery";
import "select2/dist/css/select2.min.css"; // Import Select2 CSS
import "select2"; // Import Select2 JS
function RrbDropdown({
    selectData,
    setFiltersId,
    setSelectData,
    filtersId,
    removeFilter,
    decodedToken,
    showFilter
  }) {
  useEffect(() => {
    // Initialize select2 with Bootstrap theme
    $(".select2bs4").select2({
      theme: "bootstrap4",
    });
    // Handle change event and sync with Formik state
    $(".select2bs4").on("change", (e) => {
      const { name, value } = e.target;
      if (name === "rrb_id") {
        // setSelectData({
        //   ...selectData,

        // });
        setFiltersId({
          ...filtersId,
          rrbId: value,
        });
      }
      if (value === "") {
        removeFilter();
      }
    });

    // Cleanup on unmount
    return () => {
      $(".select2bs4").select2("destroy");
    };
  }, [filtersId]);
  return (
    <RrbDropdownUi
      selectData={selectData}
      filtersId={filtersId}
      removeFilter={removeFilter}
      decodedToken={decodedToken}
      showFilter={showFilter}
    />
  );
}

export default RrbDropdown;
